import axios from 'axios';
import request from '@/lib/request';
import { calculateAuthUrl } from '@/api/signatureClient';

export const getRequest = () => {
  const defaultRequest = {
    Params: {
      picture: '图片的Base64编码',
      url: '图像地址'
    }
  };
  return defaultRequest;
};

export const fetchOCR = (data) => {
  return request({
    method: 'POST',
    url: '/openapi/try/service',
    data,
    baseURL: ''
  });
};

export const fetchVoiceFilesTranscription = (data) => {
  return request({
    method: 'POST',
    url: '/openapi/try/speech',
    baseURL: '',
    data,
    timeout: 0,
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

export const fetchIdentifyResult = (data) => {
  return request({
    method: 'POST',
    url: '/openapi/try/image/paper',
    data,
    baseURL: '',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded'
    }
  });
};

export const getOssToken = () => {
  return request({
    method: 'get',
    url: '/openapi/getOssConfig',
    baseURL: ''
  });
};

export const exportReport = (params) => {
  return axios({
    method: 'get',
    url: calculateAuthUrl(
      `https://aiverify.100tal.com/dx/audit/result/${params.uuid}`
    )
    // url: calculateAuthUrl('http://49.232.127.57:8080/dx/audit/result/ea05af41-34e3-49b8-bb0b-1a87b8a439bc')
  });
};
